import { useRouter } from "next/router";

function Home() {
	const router = useRouter();
	if (router.isReady) {
		router.replace("/contracts").then();
	}
	return null;
}
export default Home;
